import { Alert, AlertIcon, Box, Button, Heading, Spinner, Text, VStack } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import AuthContext from "./AuthContext";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";

export default function AcceptAgencyInvite() {
  const baseUrl = getHostDomain();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const { getAgencies } = useContext(AgencyContext);

  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`/login?redirect=/accept-agency-invite?token=${token}`);
      return;
    }
    if (!token) {
      setStatus("error");
      setErrorMsg("Missing invite token.");
      return;
    }
    acceptInvite();
  }, [isAuthenticated, token]);

  const acceptInvite = async () => {
    try {
      setStatus("loading");
      await fetchController(
        baseUrl + `/api/v1/agency/staff/accept_invite`,
        "POST",
        { token }
      );
      setStatus("success");
      toast.success("You've joined the agency!");
      await getAgencies();
      setTimeout(() => navigate("/agency/getting-started"), 1500);
    } catch (err) {
      setStatus("error");
      setErrorMsg(err?.response?.data?.detail || "Failed to accept invite. It may have expired.");
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <VStack spacing={4} p={8} maxW="md" textAlign="center">
        <Heading size="md">Agency Invite</Heading>
        {status === "loading" && (
          <>
            <Spinner size="lg" />
            <Text>Accepting invite…</Text>
          </>
        )}
        {status === "success" && (
          <Alert status="success" borderRadius="md">
            <AlertIcon />
            Invite accepted! Redirecting to agency panel…
          </Alert>
        )}
        {status === "error" && (
          <>
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              {errorMsg}
            </Alert>
            <Button colorScheme="blue" onClick={() => navigate("/")}>
              Go to Dashboard
            </Button>
          </>
        )}
      </VStack>
    </Box>
  );
}
